/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as CancelarExclusaoRouteImport } from './routes/cancelar-exclusao'
import { Route as DoctorRouteImport } from './routes/doctor'
import { Route as DoctorLoginRouteImport } from './routes/doctor-login'
import { Route as ExcluirContaRouteImport } from './routes/excluir-conta'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAdminFeatureFlagsRouteImport } from './routes/_authenticated/admin-feature-flags'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin-users'
import { Route as AuthenticatedAppointmentsRouteImport } from './routes/_authenticated/appointments'
import { Route as AuthenticatedAssistRouteImport } from './routes/_authenticated/assist'
import { Route as AuthenticatedCheckupRouteImport } from './routes/_authenticated/checkup'
import { Route as AuthenticatedCollectDataRouteImport } from './routes/_authenticated/collect-data'
import { Route as AuthenticatedExploreRouteImport } from './routes/_authenticated/explore'
import { Route as AuthenticatedGamificationRouteImport } from './routes/_authenticated/gamification'
import { Route as AuthenticatedLabTestsRouteImport } from './routes/_authenticated/lab-tests'
import { Route as AuthenticatedMedicationsRouteImport } from './routes/_authenticated/medications'
import { Route as AuthenticatedMindRouteImport } from './routes/_authenticated/mind'
import { Route as AuthenticatedMoveRouteImport } from './routes/_authenticated/move'
import { Route as AuthenticatedNutritionRouteImport } from './routes/_authenticated/nutrition'
import { Route as AuthenticatedNutritionGuideRouteImport } from './routes/_authenticated/nutrition-guide'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPulseRouteImport } from './routes/_authenticated/pulse'
import { Route as AuthenticatedReportRouteImport } from './routes/_authenticated/report'
import { Route as AuthenticatedRewardsRouteImport } from './routes/_authenticated/rewards'
import { Route as AuthenticatedSharingRouteImport } from './routes/_authenticated/sharing'
import { Route as AuthenticatedSleepRouteImport } from './routes/_authenticated/sleep'
import { Route as AuthenticatedVaccinesRouteImport } from './routes/_authenticated/vaccines'
import { Route as DoctorIndexRouteImport } from './routes/doctor/index'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'
import { Route as AuthenticatedMoveActivityIdRouteImport } from './routes/_authenticated/move_.$activityId'
import { Route as AuthenticatedMoveActivitiesRouteImport } from './routes/_authenticated/move_.activities'
import { Route as AuthenticatedStravaCallbackRouteImport } from './routes/_authenticated/strava.callback'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const CancelarExclusaoRoute = CancelarExclusaoRouteImport.update({
  id: '/cancelar-exclusao',
  path: '/cancelar-exclusao',
  getParentRoute: () => rootRouteImport,
} as any)
const DoctorRoute = DoctorRouteImport.update({
  id: '/doctor',
  path: '/doctor',
  getParentRoute: () => rootRouteImport,
} as any)
const DoctorLoginRoute = DoctorLoginRouteImport.update({
  id: '/doctor-login',
  path: '/doctor-login',
  getParentRoute: () => rootRouteImport,
} as any)
const ExcluirContaRoute = ExcluirContaRouteImport.update({
  id: '/excluir-conta',
  path: '/excluir-conta',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminFeatureFlagsRoute =
  AuthenticatedAdminFeatureFlagsRouteImport.update({
    id: '/admin-feature-flags',
    path: '/admin-feature-flags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/admin-users',
  path: '/admin-users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppointmentsRoute =
  AuthenticatedAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssistRoute = AuthenticatedAssistRouteImport.update({
  id: '/assist',
  path: '/assist',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCheckupRoute = AuthenticatedCheckupRouteImport.update({
  id: '/checkup',
  path: '/checkup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCollectDataRoute =
  AuthenticatedCollectDataRouteImport.update({
    id: '/collect-data',
    path: '/collect-data',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedExploreRoute = AuthenticatedExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGamificationRoute =
  AuthenticatedGamificationRouteImport.update({
    id: '/gamification',
    path: '/gamification',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLabTestsRoute = AuthenticatedLabTestsRouteImport.update({
  id: '/lab-tests',
  path: '/lab-tests',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMedicationsRoute =
  AuthenticatedMedicationsRouteImport.update({
    id: '/medications',
    path: '/medications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMindRoute = AuthenticatedMindRouteImport.update({
  id: '/mind',
  path: '/mind',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMoveRoute = AuthenticatedMoveRouteImport.update({
  id: '/move',
  path: '/move',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNutritionRoute = AuthenticatedNutritionRouteImport.update({
  id: '/nutrition',
  path: '/nutrition',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNutritionGuideRoute =
  AuthenticatedNutritionGuideRouteImport.update({
    id: '/nutrition-guide',
    path: '/nutrition-guide',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPulseRoute = AuthenticatedPulseRouteImport.update({
  id: '/pulse',
  path: '/pulse',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportRoute = AuthenticatedReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRewardsRoute = AuthenticatedRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSharingRoute = AuthenticatedSharingRouteImport.update({
  id: '/sharing',
  path: '/sharing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSleepRoute = AuthenticatedSleepRouteImport.update({
  id: '/sleep',
  path: '/sleep',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVaccinesRoute = AuthenticatedVaccinesRouteImport.update({
  id: '/vaccines',
  path: '/vaccines',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const DoctorIndexRoute = DoctorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DoctorRoute,
} as any)
const SharedTokenRoute = SharedTokenRouteImport.update({
  id: '/shared/$token',
  path: '/shared/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedMoveActivityIdRoute =
  AuthenticatedMoveActivityIdRouteImport.update({
    id: '/move_/$activityId',
    path: '/move/$activityId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMoveActivitiesRoute =
  AuthenticatedMoveActivitiesRouteImport.update({
    id: '/move_/activities',
    path: '/move/activities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStravaCallbackRoute =
  AuthenticatedStravaCallbackRouteImport.update({
    id: '/strava/callback',
    path: '/strava/callback',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cancelar-exclusao': typeof CancelarExclusaoRoute
  '/doctor': typeof DoctorRouteWithChildren
  '/doctor-login': typeof DoctorLoginRoute
  '/excluir-conta': typeof ExcluirContaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/admin-feature-flags': typeof AuthenticatedAdminFeatureFlagsRoute
  '/admin-users': typeof AuthenticatedAdminUsersRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/assist': typeof AuthenticatedAssistRoute
  '/checkup': typeof AuthenticatedCheckupRoute
  '/collect-data': typeof AuthenticatedCollectDataRoute
  '/explore': typeof AuthenticatedExploreRoute
  '/gamification': typeof AuthenticatedGamificationRoute
  '/lab-tests': typeof AuthenticatedLabTestsRoute
  '/medications': typeof AuthenticatedMedicationsRoute
  '/mind': typeof AuthenticatedMindRoute
  '/move': typeof AuthenticatedMoveRoute
  '/nutrition': typeof AuthenticatedNutritionRoute
  '/nutrition-guide': typeof AuthenticatedNutritionGuideRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/pulse': typeof AuthenticatedPulseRoute
  '/report': typeof AuthenticatedReportRoute
  '/rewards': typeof AuthenticatedRewardsRoute
  '/sharing': typeof AuthenticatedSharingRoute
  '/sleep': typeof AuthenticatedSleepRoute
  '/vaccines': typeof AuthenticatedVaccinesRoute
  '/shared/$token': typeof SharedTokenRoute
  '/doctor/': typeof DoctorIndexRoute
  '/move/$activityId': typeof AuthenticatedMoveActivityIdRoute
  '/move/activities': typeof AuthenticatedMoveActivitiesRoute
  '/strava/callback': typeof AuthenticatedStravaCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cancelar-exclusao': typeof CancelarExclusaoRoute
  '/doctor-login': typeof DoctorLoginRoute
  '/excluir-conta': typeof ExcluirContaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/admin-feature-flags': typeof AuthenticatedAdminFeatureFlagsRoute
  '/admin-users': typeof AuthenticatedAdminUsersRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/assist': typeof AuthenticatedAssistRoute
  '/checkup': typeof AuthenticatedCheckupRoute
  '/collect-data': typeof AuthenticatedCollectDataRoute
  '/explore': typeof AuthenticatedExploreRoute
  '/gamification': typeof AuthenticatedGamificationRoute
  '/lab-tests': typeof AuthenticatedLabTestsRoute
  '/medications': typeof AuthenticatedMedicationsRoute
  '/mind': typeof AuthenticatedMindRoute
  '/move': typeof AuthenticatedMoveRoute
  '/nutrition': typeof AuthenticatedNutritionRoute
  '/nutrition-guide': typeof AuthenticatedNutritionGuideRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/pulse': typeof AuthenticatedPulseRoute
  '/report': typeof AuthenticatedReportRoute
  '/rewards': typeof AuthenticatedRewardsRoute
  '/sharing': typeof AuthenticatedSharingRoute
  '/sleep': typeof AuthenticatedSleepRoute
  '/vaccines': typeof AuthenticatedVaccinesRoute
  '/shared/$token': typeof SharedTokenRoute
  '/doctor': typeof DoctorIndexRoute
  '/move/$activityId': typeof AuthenticatedMoveActivityIdRoute
  '/move/activities': typeof AuthenticatedMoveActivitiesRoute
  '/strava/callback': typeof AuthenticatedStravaCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/cancelar-exclusao': typeof CancelarExclusaoRoute
  '/doctor': typeof DoctorRouteWithChildren
  '/doctor-login': typeof DoctorLoginRoute
  '/excluir-conta': typeof ExcluirContaRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/security': typeof SecurityRoute
  '/terms': typeof TermsRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/admin-feature-flags': typeof AuthenticatedAdminFeatureFlagsRoute
  '/_authenticated/admin-users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/appointments': typeof AuthenticatedAppointmentsRoute
  '/_authenticated/assist': typeof AuthenticatedAssistRoute
  '/_authenticated/checkup': typeof AuthenticatedCheckupRoute
  '/_authenticated/collect-data': typeof AuthenticatedCollectDataRoute
  '/_authenticated/explore': typeof AuthenticatedExploreRoute
  '/_authenticated/gamification': typeof AuthenticatedGamificationRoute
  '/_authenticated/lab-tests': typeof AuthenticatedLabTestsRoute
  '/_authenticated/medications': typeof AuthenticatedMedicationsRoute
  '/_authenticated/mind': typeof AuthenticatedMindRoute
  '/_authenticated/move': typeof AuthenticatedMoveRoute
  '/_authenticated/nutrition': typeof AuthenticatedNutritionRoute
  '/_authenticated/nutrition-guide': typeof AuthenticatedNutritionGuideRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/pulse': typeof AuthenticatedPulseRoute
  '/_authenticated/report': typeof AuthenticatedReportRoute
  '/_authenticated/rewards': typeof AuthenticatedRewardsRoute
  '/_authenticated/sharing': typeof AuthenticatedSharingRoute
  '/_authenticated/sleep': typeof AuthenticatedSleepRoute
  '/_authenticated/vaccines': typeof AuthenticatedVaccinesRoute
  '/shared/$token': typeof SharedTokenRoute
  '/doctor/': typeof DoctorIndexRoute
  '/_authenticated/move_/$activityId': typeof AuthenticatedMoveActivityIdRoute
  '/_authenticated/move_/activities': typeof AuthenticatedMoveActivitiesRoute
  '/_authenticated/strava/callback': typeof AuthenticatedStravaCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cancelar-exclusao'
    | '/doctor'
    | '/doctor-login'
    | '/excluir-conta'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/security'
    | '/terms'
    | '/verify-email'
    | '/admin'
    | '/admin-feature-flags'
    | '/admin-users'
    | '/appointments'
    | '/assist'
    | '/checkup'
    | '/collect-data'
    | '/explore'
    | '/gamification'
    | '/lab-tests'
    | '/medications'
    | '/mind'
    | '/move'
    | '/nutrition'
    | '/nutrition-guide'
    | '/profile'
    | '/pulse'
    | '/report'
    | '/rewards'
    | '/sharing'
    | '/sleep'
    | '/vaccines'
    | '/shared/$token'
    | '/doctor/'
    | '/move/$activityId'
    | '/move/activities'
    | '/strava/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cancelar-exclusao'
    | '/doctor-login'
    | '/excluir-conta'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/security'
    | '/terms'
    | '/verify-email'
    | '/admin'
    | '/admin-feature-flags'
    | '/admin-users'
    | '/appointments'
    | '/assist'
    | '/checkup'
    | '/collect-data'
    | '/explore'
    | '/gamification'
    | '/lab-tests'
    | '/medications'
    | '/mind'
    | '/move'
    | '/nutrition'
    | '/nutrition-guide'
    | '/profile'
    | '/pulse'
    | '/report'
    | '/rewards'
    | '/sharing'
    | '/sleep'
    | '/vaccines'
    | '/shared/$token'
    | '/doctor'
    | '/move/$activityId'
    | '/move/activities'
    | '/strava/callback'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/cancelar-exclusao'
    | '/doctor'
    | '/doctor-login'
    | '/excluir-conta'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/security'
    | '/terms'
    | '/verify-email'
    | '/_authenticated/admin'
    | '/_authenticated/admin-feature-flags'
    | '/_authenticated/admin-users'
    | '/_authenticated/appointments'
    | '/_authenticated/assist'
    | '/_authenticated/checkup'
    | '/_authenticated/collect-data'
    | '/_authenticated/explore'
    | '/_authenticated/gamification'
    | '/_authenticated/lab-tests'
    | '/_authenticated/medications'
    | '/_authenticated/mind'
    | '/_authenticated/move'
    | '/_authenticated/nutrition'
    | '/_authenticated/nutrition-guide'
    | '/_authenticated/profile'
    | '/_authenticated/pulse'
    | '/_authenticated/report'
    | '/_authenticated/rewards'
    | '/_authenticated/sharing'
    | '/_authenticated/sleep'
    | '/_authenticated/vaccines'
    | '/shared/$token'
    | '/doctor/'
    | '/_authenticated/move_/$activityId'
    | '/_authenticated/move_/activities'
    | '/_authenticated/strava/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  CancelarExclusaoRoute: typeof CancelarExclusaoRoute
  DoctorRoute: typeof DoctorRouteWithChildren
  DoctorLoginRoute: typeof DoctorLoginRoute
  ExcluirContaRoute: typeof ExcluirContaRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SecurityRoute: typeof SecurityRoute
  TermsRoute: typeof TermsRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  SharedTokenRoute: typeof SharedTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cancelar-exclusao': {
      id: '/cancelar-exclusao'
      path: '/cancelar-exclusao'
      fullPath: '/cancelar-exclusao'
      preLoaderRoute: typeof CancelarExclusaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/doctor': {
      id: '/doctor'
      path: '/doctor'
      fullPath: '/doctor'
      preLoaderRoute: typeof DoctorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/doctor-login': {
      id: '/doctor-login'
      path: '/doctor-login'
      fullPath: '/doctor-login'
      preLoaderRoute: typeof DoctorLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/excluir-conta': {
      id: '/excluir-conta'
      path: '/excluir-conta'
      fullPath: '/excluir-conta'
      preLoaderRoute: typeof ExcluirContaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin-feature-flags': {
      id: '/_authenticated/admin-feature-flags'
      path: '/admin-feature-flags'
      fullPath: '/admin-feature-flags'
      preLoaderRoute: typeof AuthenticatedAdminFeatureFlagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin-users': {
      id: '/_authenticated/admin-users'
      path: '/admin-users'
      fullPath: '/admin-users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments': {
      id: '/_authenticated/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assist': {
      id: '/_authenticated/assist'
      path: '/assist'
      fullPath: '/assist'
      preLoaderRoute: typeof AuthenticatedAssistRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checkup': {
      id: '/_authenticated/checkup'
      path: '/checkup'
      fullPath: '/checkup'
      preLoaderRoute: typeof AuthenticatedCheckupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/collect-data': {
      id: '/_authenticated/collect-data'
      path: '/collect-data'
      fullPath: '/collect-data'
      preLoaderRoute: typeof AuthenticatedCollectDataRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/explore': {
      id: '/_authenticated/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AuthenticatedExploreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gamification': {
      id: '/_authenticated/gamification'
      path: '/gamification'
      fullPath: '/gamification'
      preLoaderRoute: typeof AuthenticatedGamificationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/lab-tests': {
      id: '/_authenticated/lab-tests'
      path: '/lab-tests'
      fullPath: '/lab-tests'
      preLoaderRoute: typeof AuthenticatedLabTestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/medications': {
      id: '/_authenticated/medications'
      path: '/medications'
      fullPath: '/medications'
      preLoaderRoute: typeof AuthenticatedMedicationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mind': {
      id: '/_authenticated/mind'
      path: '/mind'
      fullPath: '/mind'
      preLoaderRoute: typeof AuthenticatedMindRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/move': {
      id: '/_authenticated/move'
      path: '/move'
      fullPath: '/move'
      preLoaderRoute: typeof AuthenticatedMoveRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/nutrition': {
      id: '/_authenticated/nutrition'
      path: '/nutrition'
      fullPath: '/nutrition'
      preLoaderRoute: typeof AuthenticatedNutritionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/nutrition-guide': {
      id: '/_authenticated/nutrition-guide'
      path: '/nutrition-guide'
      fullPath: '/nutrition-guide'
      preLoaderRoute: typeof AuthenticatedNutritionGuideRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pulse': {
      id: '/_authenticated/pulse'
      path: '/pulse'
      fullPath: '/pulse'
      preLoaderRoute: typeof AuthenticatedPulseRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/report': {
      id: '/_authenticated/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthenticatedReportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rewards': {
      id: '/_authenticated/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof AuthenticatedRewardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sharing': {
      id: '/_authenticated/sharing'
      path: '/sharing'
      fullPath: '/sharing'
      preLoaderRoute: typeof AuthenticatedSharingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sleep': {
      id: '/_authenticated/sleep'
      path: '/sleep'
      fullPath: '/sleep'
      preLoaderRoute: typeof AuthenticatedSleepRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vaccines': {
      id: '/_authenticated/vaccines'
      path: '/vaccines'
      fullPath: '/vaccines'
      preLoaderRoute: typeof AuthenticatedVaccinesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/doctor/': {
      id: '/doctor/'
      path: '/'
      fullPath: '/doctor/'
      preLoaderRoute: typeof DoctorIndexRouteImport
      parentRoute: typeof DoctorRoute
    }
    '/shared/$token': {
      id: '/shared/$token'
      path: '/shared/$token'
      fullPath: '/shared/$token'
      preLoaderRoute: typeof SharedTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/move_/$activityId': {
      id: '/_authenticated/move_/$activityId'
      path: '/move/$activityId'
      fullPath: '/move/$activityId'
      preLoaderRoute: typeof AuthenticatedMoveActivityIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/move_/activities': {
      id: '/_authenticated/move_/activities'
      path: '/move/activities'
      fullPath: '/move/activities'
      preLoaderRoute: typeof AuthenticatedMoveActivitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/strava/callback': {
      id: '/_authenticated/strava/callback'
      path: '/strava/callback'
      fullPath: '/strava/callback'
      preLoaderRoute: typeof AuthenticatedStravaCallbackRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedAdminFeatureFlagsRoute: typeof AuthenticatedAdminFeatureFlagsRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAppointmentsRoute: typeof AuthenticatedAppointmentsRoute
  AuthenticatedAssistRoute: typeof AuthenticatedAssistRoute
  AuthenticatedCheckupRoute: typeof AuthenticatedCheckupRoute
  AuthenticatedCollectDataRoute: typeof AuthenticatedCollectDataRoute
  AuthenticatedExploreRoute: typeof AuthenticatedExploreRoute
  AuthenticatedGamificationRoute: typeof AuthenticatedGamificationRoute
  AuthenticatedLabTestsRoute: typeof AuthenticatedLabTestsRoute
  AuthenticatedMedicationsRoute: typeof AuthenticatedMedicationsRoute
  AuthenticatedMindRoute: typeof AuthenticatedMindRoute
  AuthenticatedMoveRoute: typeof AuthenticatedMoveRoute
  AuthenticatedNutritionRoute: typeof AuthenticatedNutritionRoute
  AuthenticatedNutritionGuideRoute: typeof AuthenticatedNutritionGuideRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedPulseRoute: typeof AuthenticatedPulseRoute
  AuthenticatedReportRoute: typeof AuthenticatedReportRoute
  AuthenticatedRewardsRoute: typeof AuthenticatedRewardsRoute
  AuthenticatedSharingRoute: typeof AuthenticatedSharingRoute
  AuthenticatedSleepRoute: typeof AuthenticatedSleepRoute
  AuthenticatedVaccinesRoute: typeof AuthenticatedVaccinesRoute
  AuthenticatedMoveActivityIdRoute: typeof AuthenticatedMoveActivityIdRoute
  AuthenticatedMoveActivitiesRoute: typeof AuthenticatedMoveActivitiesRoute
  AuthenticatedStravaCallbackRoute: typeof AuthenticatedStravaCallbackRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedAdminFeatureFlagsRoute: AuthenticatedAdminFeatureFlagsRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAppointmentsRoute: AuthenticatedAppointmentsRoute,
  AuthenticatedAssistRoute: AuthenticatedAssistRoute,
  AuthenticatedCheckupRoute: AuthenticatedCheckupRoute,
  AuthenticatedCollectDataRoute: AuthenticatedCollectDataRoute,
  AuthenticatedExploreRoute: AuthenticatedExploreRoute,
  AuthenticatedGamificationRoute: AuthenticatedGamificationRoute,
  AuthenticatedLabTestsRoute: AuthenticatedLabTestsRoute,
  AuthenticatedMedicationsRoute: AuthenticatedMedicationsRoute,
  AuthenticatedMindRoute: AuthenticatedMindRoute,
  AuthenticatedMoveRoute: AuthenticatedMoveRoute,
  AuthenticatedNutritionRoute: AuthenticatedNutritionRoute,
  AuthenticatedNutritionGuideRoute: AuthenticatedNutritionGuideRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedPulseRoute: AuthenticatedPulseRoute,
  AuthenticatedReportRoute: AuthenticatedReportRoute,
  AuthenticatedRewardsRoute: AuthenticatedRewardsRoute,
  AuthenticatedSharingRoute: AuthenticatedSharingRoute,
  AuthenticatedSleepRoute: AuthenticatedSleepRoute,
  AuthenticatedVaccinesRoute: AuthenticatedVaccinesRoute,
  AuthenticatedMoveActivityIdRoute: AuthenticatedMoveActivityIdRoute,
  AuthenticatedMoveActivitiesRoute: AuthenticatedMoveActivitiesRoute,
  AuthenticatedStravaCallbackRoute: AuthenticatedStravaCallbackRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface DoctorRouteChildren {
  DoctorIndexRoute: typeof DoctorIndexRoute
}

const DoctorRouteChildren: DoctorRouteChildren = {
  DoctorIndexRoute: DoctorIndexRoute,
}

const DoctorRouteWithChildren =
  DoctorRoute._addFileChildren(DoctorRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CancelarExclusaoRoute: CancelarExclusaoRoute,
  DoctorRoute: DoctorRouteWithChildren,
  DoctorLoginRoute: DoctorLoginRoute,
  ExcluirContaRoute: ExcluirContaRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SecurityRoute: SecurityRoute,
  TermsRoute: TermsRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  SharedTokenRoute: SharedTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
